"use strict";
/*
 * Created on 26.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var SupplierSiteBinding_1 = require("../model/SupplierSiteBinding");

var SupplierSiteBindingConverter_1 = require("./SupplierSiteBindingConverter");
/**
 *
 * Implementation of {@link SupplierSiteBindingConverter}
 *
 *
 * @author ZSr
 */


var SupplierSiteBindingConverterImpl =
/*#__PURE__*/
function (_SupplierSiteBindingC) {
  _inherits(SupplierSiteBindingConverterImpl, _SupplierSiteBindingC);

  function SupplierSiteBindingConverterImpl() {
    _classCallCheck(this, SupplierSiteBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierSiteBindingConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierSiteBindingConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SupplierSiteBinding_1.SupplierSiteBinding(SupplierSiteBinding_1.SupplierSiteBinding.schema.id.valueOf(conversions.documentToClassId(source)), SupplierSiteBinding_1.SupplierSiteBinding.schema.externalId.valueOfField(source), SupplierSiteBinding_1.SupplierSiteBinding.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), SupplierSiteBinding_1.SupplierSiteBinding.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SupplierSiteBinding_1.SupplierSiteBinding.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SupplierSiteBinding_1.SupplierSiteBinding.schema.preferred.valueOfField(source), SupplierSiteBinding_1.SupplierSiteBinding.schema.validFrom.valueOfField(source), SupplierSiteBinding_1.SupplierSiteBinding.schema.validTo.valueOfField(source), SupplierSiteBinding_1.SupplierSiteBinding.schema.stockRef.valueOfField(source), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), SupplierSiteBinding_1.SupplierSiteBinding.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        preferred: source.preferred,
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo),
        stockRef: source.stockRef,
        stateFlags: source.stateFlags.serialize(),
        processed: source.processed
      });
      return result;
    }
  }]);

  return SupplierSiteBindingConverterImpl;
}(SupplierSiteBindingConverter_1.SupplierSiteBindingConverter);

exports.SupplierSiteBindingConverterImpl = SupplierSiteBindingConverterImpl;